import { render, staticRenderFns } from "./ProjectResultConfig2Modal.vue?vue&type=template&id=633100a4&scoped=true"
import script from "./ProjectResultConfig2Modal.vue?vue&type=script&lang=js"
export * from "./ProjectResultConfig2Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633100a4",
  null
  
)

export default component.exports